import React, { ReactNode } from 'react';
import css from './WizardStepWrapper.module.css';
import clsx from 'clsx';
import { StackedColumn, StackedColumnSpacing } from '../../../../../core';
import { AppointmentDetails } from '../../../appointmentDetails';
import { WizardStepFooter } from '../wizardStepFooter';
import { ResponsiveSizeUtility } from '../../../../../utils';
import { useScreenSize } from '@mchs/web-core';

export interface WizardStepWrapperProps {
  children: ReactNode;
  includeDetail?: boolean;
  collapsableDetail?: boolean;
  continueText?: string;
  specialFooter?: ReactNode;
  stickyWhenNarrow: boolean;
  onContinue?: () => void;
}

const WizardStepWrapper: React.FC<WizardStepWrapperProps> = (
  props: WizardStepWrapperProps
) => {
  const screenSize = useScreenSize();

  const narrowWidth = ResponsiveSizeUtility.isNarrowWidth(screenSize.width);

  return (
    <div
      className={clsx(
        css.stepWrapperContent,
        narrowWidth && props.stickyWhenNarrow
          ? css.stepWrapperContentStickyFooter
          : null
      )}
    >
      <div className={css.stepWrapper}>
        <StackedColumn spacing={StackedColumnSpacing.Wider}>
          {props.includeDetail || props.includeDetail === undefined ? (
            <AppointmentDetails collapsableDetail={props.collapsableDetail} />
          ) : null}
          <div className={css.content}>{props.children}</div>
        </StackedColumn>
      </div>
      <div
        className={clsx(
          narrowWidth && props.stickyWhenNarrow ? css.footerContent : null
        )}
      >
        <WizardStepFooter
          narrowWidth={narrowWidth}
          continueText={props.continueText}
          mayBeSticky={props.stickyWhenNarrow}
          specialFooter={props.specialFooter}
          onContinue={props.onContinue}
        />
      </div>
    </div>
  );
};

export default WizardStepWrapper;
